<script>
  'use strict'

  import { onMount } from 'svelte';
  
  import {
    tileX,
    tileY,
    _tileMap,
    _tilesCollections,
    _currentMode,
    _selectedTileIdx,
    _centerMap,
    _newProject,
    _gridGap,
  } from "../store/store";

  let nbTilesX, nbTilesY;
  let tileMap = [];
  let tiles = null;
  let selectedTileIdx = 1;
  let drawingMode = false;
  let pipetteMode = false;
  let currentMode = 'click';
  let previousXY = '';

  onMount(async () => {
		if (isMapEmpty($_tileMap)) {
      generateEmptyMap();
    }
	});

  // -------------------------------------------------
  _newProject.subscribe(evt => {
    if (evt) {
      generateEmptyMap();
      _newProject.set(false);
    }
  })

  tileX.subscribe(e => {
    nbTilesX = e;
    updateMapX();
  });

  tileY.subscribe(e => {
    nbTilesY = e;
    updateMapY();
  });

  _tilesCollections.subscribe(data => {
    tiles = data;
  })

  _tileMap.subscribe(data => {
    tileMap = data;
  })

  _currentMode.subscribe(data => {
    currentMode = data;
  })

  _selectedTileIdx.subscribe(data => {
    selectedTileIdx = data;
  })

  $: drawingMode, pipetteMode, getCursorOnMode();

  // -------------------------------------------------
  function isMapEmpty(map) {
    const isEmpty = $_tileMap.map(elm => {
      return elm.every(tile => tile === '_');
    })
    .every(row => row === true);
    return isEmpty;
  }

  function generateEmptyMap() {
      tileMap = [];
      for(let i = 0; i < nbTilesY; i++) {
        tileMap.push((Array.from(Array(nbTilesX).keys()).map(() => '_')));
      }
      _tileMap.set(tileMap);
  }

  function updateMapX() {
    if (nbTilesX && nbTilesY && tileMap.length > 0) {
      let addOrSub = nbTilesX - tileMap[0].length;
      for(let i = 0; i < nbTilesY; i++) {
        for(let j= 0; j < Math.abs(addOrSub); j++) {
          addOrSub > 0 ? tileMap[i].push('_') : tileMap[i].pop();
        }
      }
      _tileMap.set(tileMap);
    }
  }

  function updateMapY() {
    if (nbTilesX && nbTilesY && tileMap.length > 0) {
      let addOrSub = nbTilesY - tileMap.length;
      for(let i= 0; i < Math.abs(addOrSub); i++) {
        addOrSub > 0 ? tileMap.push((Array.from(Array(nbTilesX).keys()).map(() => '_')))
                   : tileMap.pop();
      }
      _tileMap.set(tileMap);
    }
  }

  function getCoord(x, y) {
    drawingMode = false;
    if (pipetteMode) {
      _selectedTileIdx.set(tileMap[y][x]);
      pipetteMode = false;
    } else {
      tileMap[y][x] = selectedTileIdx;
      _tileMap.set(tileMap);
    }
  }
  
  function getCoordMove(x, y) {
    if (drawingMode & `${x}${y}` !== previousXY) {
      tileMap[y][x] = selectedTileIdx;
      _tileMap.set(tileMap);
      previousXY = `${x}${y}`;
    }
  }

  function keyControl(event) {
    switch (event.keyCode) {
      case 66:
          pipetteMode = false;
          drawingMode = !drawingMode;
          _currentMode.set(drawingMode ? 'brush' : 'click');
        break;
      case 80:
          drawingMode = false;
          pipetteMode = !pipetteMode;
          _currentMode.set('picker');
        break;
      case 39:
          _selectedTileIdx.set(selectedTileIdx + 1 >= tiles.length ? 0 : selectedTileIdx += 1);
        break;
      case 37:
          _selectedTileIdx.set(selectedTileIdx - 1 < 0 ? tiles.length - 1 : selectedTileIdx -= 1);
        break;
        case 38:
          _gridGap.set($_gridGap + 1);
        break;
        case 40:
          const decr = $_gridGap > 0 ? $_gridGap - 1 : 0
          _gridGap.set(decr);
        break;
      default:
        //  console.log('keycode: ', event.keyCode);
        break;
    }
  }

  function mouseLeaveMap() {
    drawingMode = false;
  }

  function getCursorOnMode() {
    if (drawingMode) {
      _currentMode.set('brush');
    } else if (pipetteMode) {
      _currentMode.set('picker');
    } else {
      _currentMode.set('click');
    }
  }

</script>

<svelte:window on:keydown={keyControl}/>

{#if tileMap.length > 0}
<div class="{$_centerMap ? 'map-container' : ''}">
  <div class="grid-map" on:mouseleave="{mouseLeaveMap}">
    {#each Array(nbTilesY) as _, iY}
      {#each Array(nbTilesX) as _, iX}
        <div on:click={ () => getCoord(iX, iY) } on:mousemove={ () => getCoordMove(iX, iY) }>
          {#if tileMap[iY][iX] == '_'}
            <div class="
              empty-tile selectable tile-size 
              {drawingMode ? 'brush-mode': ''}
              {pipetteMode ? 'picker-mode' : ''}"
            ></div>
          {:else}
            <img
              src="{ tiles[tileMap[iY][iX]] }"
              alt="{tiles[tileMap[iY][iX]]}"
              class="
                selectable tile-size
                {drawingMode ? 'brush-mode': ''}
                {pipetteMode ? 'picker-mode' : ''}"
              >
          {/if}
        </div>
      {/each}
    {/each}
  </div>
</div>
{/if}


<style>
.map-container {
  display: grid;
  place-items: center;
  height: 99%;
}

  .empty-tile {
    width: 100%;
    height: 100%;
    padding: 2px;
    background: lightgray;
    box-sizing: border-box;
    border: 1px solid #a1a1a1;
  }

  .tile-size {
    width: var(--grid-tile-size);
    aspect-ratio: 1/1;
  }
  .grid-map {
    display: grid;
    grid-template-columns: repeat(var(--tileX), var(--grid-tile-size));
    grid-template-rows: repeat(var(--tileY), var(--grid-tile-size));
    gap: var(--grid-gap);
    background: var(--grid-color);
    width: fit-content;
  }

  .selectable:hover {
    opacity: 0.6;
    cursor: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABBJJREFUWEftl19II2cQwGeIASWloHJyeFfj01GTVajt6RVB4a4vCYh/+hB98NHEXluqckVNiF4jqzkONJTSmvVRqD7UfyD+gbaID7bJnTmEdW1fitu7k6po4x32BLd+5VuSdLPuJrFFpNB92++b+ea3M/PNzCJc8oOXbB/+ewCEkLcA4E0AuAYAr8c8+AIAngPAT4j45DxezcgDhJAcAOja3Ny8Ozs7e2VlZQV4noft7W3ZVmFhITAMA9XV1VBXV7dXUlLyJQA8QMRX6WDSAhBC3ud5/guWZa9OTEykO0/eb2pqAo/H8xvDMB8h4mQqpZQAhJAujuP8bW1tQAjJyHhcCBFhZGQEnE5nNyI+0FPWBaDGBwYG/B6PR1M3Ozsbjo+P5b3i4mLY2trSlGNZFtxuty6EJgB1O8dx37hcrqRDTSYTDA8Pg81m+8HhcLy7uroq70ej0SeHh4e/Ly4u3u7s7ISjo6MkPeoJl8vVgIgzasozADTheJ7/pays7KrS7fX19cCy7COLxfIBALysqqr6OQ6wv78/mp+f7ySEvC0Iwlcej+fmzEyyrbW1tefl5eVmRPxTCaEFcL+5ublPmXDU+PT0dC8i9lNlQsgNLYD4wYQQb0NDg08J0djYCJOTkz2I6E8JIAjCrsViuRIXom4Ph8OPrFZrhcJASgAqt7GxEa6oqLipDEcoFHpWWVn5hi4ALTJ+vz/S09OTkAkGgzST30HENTXA7u6uvBQKheQQKA+m4RgdHX3sdP697PV6wefzWRBxM3FbVErNdrv964WFhcSyKIrfm83mOyq5GwDwWtKXIEbUCSaK4rdK3ZqaGlheXm5ExGk9gHu5ubkPo9GovJ+Xlwft7e2vTk5OktK6v78/ESKFV7p6e3vvKSGMRqMpEAjkHBwcyMsFBQWws7PzCSJ+rgfgMxgM3tPTU/XHJN5bWlr+GBsbM6kFaN0wGo1+SZJ0dWMJ/Bki3r8UAIPBAJIkpQTQCsGxJElJTcXn8+VpeaCvr69LuZ6VlZUTCASy4yEoKioCURRThkArCb8zm83vaSShUZWEGxpJSHVvx9dtNhvMz8+nTMIz15DjOGhtbf1H15DjuMfKcj44OAjd3d3615CSXmQh4nn+V4ZhzEme04jlhZRiOiOMj4+nL8UX0YzobLC+vv6stLS0OG0zit1V3XY8NDQEdrv9R4fDcUvVjg+WlpbudHR0nGnHsXKeWTtWVrZLG0iUEMFgUB7Jzvv865FMAVEfiUToUHptamoqIw6acG63m8b8Y60pKOUt0LJACDEAwKfhcPjDubm563QsFwQB9vb2gJZX5VheW1v71Gq10rH8oTrhtM5OO5ZrXNOS2I8JHSziJZm2u6exH5NEr8/EXecGyOTQ88j8D/AXQDZzPwSqKhwAAAAASUVORK5CYII=')16 16, auto;
  }
  
  .brush-mode:hover {
    cursor: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAspJREFUWEftlU9o03AUx3+va0sbbe0hjUFtJ6zgKGjJZAUPjkLdRoews5cx8KbsILvIYPjnODx4muDBw8DTQC2MUEtRKsNO6JwWOqz2kHSd3cKoa9VsobonGRaysbmlxs7DAj9IyI/3/fy+7/3eA3LADxywPvm/ABDx9tLS0jWWZd1GOVOtVhUAeOx0Oq/uFHOLA7lcTggGg1KlUuk0CsBkMhUEQah5PJ6LAFDaHncLACIigPFZ4Xn+TSQSuUkIEQBA0EI0BWBiYmKSYRivz+ejaZp+7nK5rtchmgJQFzObzW+LxWI7y7JHmgrQ09PzdHp6mpVl+QIiEtDkuSkOTE1NpQcHB1tWVla4AwHgef7jwMDA9z0BisXiZD6f94+Pjy8bdQ2DweDR4eHhTrfbPbcnACKeJoSECCGnCCHrmqXs8q7u0f7b/AaAdfVKq4eYn5/Px2KxL6Ojoz/2rIFGTo2I7bIsh0ulUp+iKOdEUVyNRqPlVCrVksvlaEVRztTjUhSVEgThLMMwjh1vwX4BEPF8IpF4ZLPZHOl0+hvP82uzs7P2crncRgihtHGcTuenQCDwNRwOYyQSOdnR0fHQYrHc+iuAbDb7YmRkZC0ajfZpxUwm02ePx7PQ1dW10dvbaw2FQm1ms1mgKCrucDheEkJeA0B11064XwcWFxezgUBAUYuK47hkd3e3pb+//zjHcScURfngcrlihJBX6gIA+U9xG2r8WoDftXaXEJJUFwD83O9B1H26ARDxSqVSud/a2iqqUxMRhVqt9sxqtd7QI9xwDSSTyczQ0NBCJpPZzL/dbn8vimKbtrL1gOh2QJKkd36/f0PNf11oe3s9BDh04NCBf+pAIpF4MjY25ojH45dUIZqm52ZmZo75fD51EOl+dPcBRLxcKBTueb3ezTErSdIywzAPAOCObvVGWnEjIoYPIyMhdKfASHE11i9D8oYwkp8xXwAAAABJRU5ErkJggg==')8 8, auto;
  }

  .picker-mode:hover {
    cursor: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAMZQTFRFAAAAu7u7dXV1Y2NjsbGx0dHRw8PDw8PDOzs7AAAAmJiY0dHRUlJSaWlpx8fHzc3NRUVFkZGRra2tj4+Pj4+Pqqqqrq6uZmZmr6+vwMDAo6OjdHR0tbW1xcXFISEhHx8fpaWlu7u7zc3NNzc3r6+vhYWFwMDAtbW1nZ2durq6s7Ozt7e3bm5uy8vLd3d3dXV1r6+vZmZmmJiYfn5+jY2Nnp6eBwcHjY2Nu7u7srKympqasLCwNjY2tbW1r6+vubm5ubm5jY2NHkmROgAAAEJ0Uk5TAIb0+rWAcqD//6ia//+HoP/73f/qLvD/VM7//23J////bVn/m/9OltlnuGH/hP//SPz//x/v//hRXYXM/9ogl5oO5VT5jAAAAJZJREFUeJzNzkcSwkAMRFGRaWBMtMk555zz/S/F2MVyJJa4t+9XSUT+XSAYCnMWiRLF4gASZk+mlJXOaEfWHOQAlXcdBXNgO7pQ2osl5odyxSuqNcbrjaZbtNqsA15h8f4tOryj23PQHwg+JHs0Fl2671+f/HCazmSn+WIp+mqNzVbw3f5wPJ0vrNP1dn/wqvd8vUX/9z5nMhIIlYtWdwAAAABJRU5ErkJggg==')8 8, auto;
  }
</style>